import React from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import ProjectNavigation from "../components/ProjectNavigation"
import ResponsiveImage from "../components/ResponsiveImage"

const ScandinavianNeckGaiter = () => {
    // Define images with their paths organized by category
    const productPhotos = [
        "/images/projects/Scandinavian Neck Gaiter/Product Photo 1",
        "/images/projects/Scandinavian Neck Gaiter/Product Photo 2",
        "/images/projects/Scandinavian Neck Gaiter/Product Photo 3",
        "/images/projects/Scandinavian Neck Gaiter/Product Photo 4"
    ]
    
    const processImages = [
        "/images/projects/Scandinavian Neck Gaiter/Process1",
        "/images/projects/Scandinavian Neck Gaiter/Process2",
        "/images/projects/Scandinavian Neck Gaiter/Process3",
        "/images/projects/Scandinavian Neck Gaiter/Process4"
    ]
    
    const scaleImages = [
        "/images/projects/Scandinavian Neck Gaiter/33",
        "/images/projects/Scandinavian Neck Gaiter/50",
        "/images/projects/Scandinavian Neck Gaiter/100",
        "/images/projects/Scandinavian Neck Gaiter/150",
        "/images/projects/Scandinavian Neck Gaiter/300",
        "/images/projects/Scandinavian Neck Gaiter/600"
    ]
    
    const otherImages = [
        "/images/projects/Scandinavian Neck Gaiter/Colors"
    ]

    // Function to create an open in new tab button
    const OpenInNewTabButton = ({ imagePath }) => (
        <a 
            href={imagePath} 
            target="_blank" 
            rel="noopener noreferrer"
            className="open-in-new-tab-btn"
        >
            Open in new tab
        </a>
    )

    return (
        <div>
            <Header />
            <ProjectNavigation currentProject="/scandinavian-neck-gaiter" />
            
            <div style={{
                textAlign: "center",
                padding: "30px 0 20px",
                marginBottom: "10px"
            }}>
                <h1 style={{ 
                    fontSize: "32px",
                    margin: "0",
                    fontWeight: "bold"
                }}>Scandinavian Neck Gaiter</h1>
                
                <p style={{
                    maxWidth: "800px",
                    margin: "20px auto 0",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    color: "#333",
                    padding: "0 20px"
                }}>
                    A versatile down filled, snap-front neck gaiter I sewed as a prototype piece for my computer aided textile print design class. I wanted to play with trompe-l'oeil and fake hand repair work in a patchwork lens while honoring the vibrant and playful Scandinavian cultural aesthetic
                </p>
            </div>

            <main>
                <div style={{ 
                    padding: "20px",
                    maxWidth: "1200px", 
                    margin: "0 auto"
                }}>
                    <h2 style={{ marginBottom: "20px" }}>Colors</h2>
                    <div style={{ 
                        display: "flex",
                        justifyContent: "center",
                        maxWidth: "600px",
                        margin: "0 auto 50px"
                    }}>
                        {otherImages.map((image, index) => (
                            <div key={`other-${index}`} style={{ width: "100%" }}>
                                <div style={{ 
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto"
                                }}>
                                    <ResponsiveImage
                                        src={`${image}.webp`}
                                        alt="Color variations for the Scandinavian Neck Gaiter"
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain",
                                            maxWidth: "500px"
                                        }}
                                        priority={true}
                                        loading="eager"
                                        sizes="(max-width: 600px) 100vw, 600px"
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <OpenInNewTabButton imagePath={`${image}.webp`} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <h2 style={{ marginBottom: "20px" }}>Product Photos</h2>
                    <div 
                        className="sg-grid-2"
                        style={{ 
                            marginBottom: "50px"
                        }}
                    >
                        {productPhotos.map((image, index) => (
                            <div key={`product-${index}`}>
                                <div style={{ 
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto"
                                }}>
                                    <ResponsiveImage
                                        src={`${image}.webp`}
                                        alt={`Scandinavian Neck Gaiter product photo ${index + 1}`}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain"
                                        }}
                                        priority={index < 2}
                                        loading={index < 2 ? "eager" : "lazy"}
                                        sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 600px"
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <OpenInNewTabButton imagePath={`${image}.webp`} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <h2 style={{ marginBottom: "20px" }}>Design Process</h2>
                    <div 
                        className="sg-grid-2"
                        style={{ 
                            marginBottom: "50px"
                        }}
                    >
                        {processImages.map((image, index) => (
                            <div key={`process-${index}`}>
                                <div style={{ 
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto"
                                }}>
                                    <ResponsiveImage
                                        src={`${image}.webp`}
                                        alt={`Scandinavian Neck Gaiter design process step ${index + 1}`}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain"
                                        }}
                                        loading="lazy"
                                        priority={false}
                                        sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 600px"
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <OpenInNewTabButton imagePath={`${image}.webp`} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <h2 style={{ marginBottom: "20px" }}>Pattern Scale Variations</h2>
                    <div 
                        className="sg-grid-3"
                        style={{ 
                            marginBottom: "50px"
                        }}
                    >
                        {scaleImages.map((image, index) => (
                            <div key={`scale-${index}`}>
                                <div style={{ 
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto"
                                }}>
                                    <ResponsiveImage
                                        src={`${image}.webp`}
                                        alt={`Pattern scale variation ${index + 1}`}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain"
                                        }}
                                        loading="lazy"
                                        priority={false}
                                        sizes="(max-width: 767px) 100vw, (max-width: 1200px) 33vw, 400px"
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <OpenInNewTabButton imagePath={`${image}.webp`} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default ScandinavianNeckGaiter
